

angular.module('theme.core.tiles', ['pascalprecht.translate'])

  .directive('tileLarge', function() {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        item: '=data'
      },
      templateUrl: 'framework/partials/ui-elements/tile-large.html',
      replace: true,
      transclude: true
    };
  })
  .directive('tileSimple', function() {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        item: '=data'
      },
      templateUrl: 'framework/partials/ui-elements/tile-simple.html',
      replace: true,
      transclude: true
    };
  })
  .directive('tileShortcut', function() {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        item: '=data'
      },
      replace: true,
      templateUrl: 'framework/partials/ui-elements/tile-shortcut.html'
    };
  })
  .component('tileKpi', {
    bindings: {
      heading: '@',
      type: '@',
      histogram: '<?',
      labels: '<?',
      min: '<?',
      max: '<?',
      value: '@',
      widget: '@'
    },
    templateUrl: 'framework/partials/ui-elements/tile-kpi.html',
    link: function(scope, element) {
      var heading = element.find('tile-heading');
      if (heading.length) {
        heading.appendTo(element.find('.tiles-heading'));
      }
    },
    controller: function($scope) {
      var self = this;

      this.labels = [];

      $scope.$watch(function(){return self.labels}, function(labels){
        if (labels && labels.length) {
          self.ticks = labels.map(function(l){ return moment(l, "YYYY-MM-DD").format("DD.MM") });
        }
      })
      
      var removeFirstAndLastLabel = function(scaleInstance) {
        // set the first and last tick to null so it does not display
        // note, ticks[0] is the last tick and ticks[length - 1] is the first
        scaleInstance.ticks[0] = null;
        scaleInstance.ticks[scaleInstance.ticks.length - 1] = null;
        // reomove middle 30% - space for value
        var count = Math.floor(scaleInstance.ticks.length * .3 / 2);
        for (var i=Math.floor((scaleInstance.ticks.length - count)/2); i<Math.ceil((scaleInstance.ticks.length + count)/2); i++) {
          scaleInstance.ticks[i] = null;
        }
      };

      var removePaddingFormScale = function(me) {
        me.paddingLeft = 0;
        me.paddingRight = 0;
      };

      this.$onInit = function() {
        if (self.widget == 'line') {
          //self.ticks = self.labels.map(function(l){ return moment(l, "YYYY-MM-DD").format("DD.MM") });
          self.chart_options = {
            responsive: true, 
            maintainAspectRatio: false, 
            scales: {
              yAxes:[{ display: false, ticks: {suggestedMin:self.min, suggestedMax:self.max}}],
              //xAxes:[{ display: false}]
              xAxes:[{
                position: 'top',
                afterTickToLabelConversion: removeFirstAndLastLabel,
                gridLines: {drawBorder: false,},
                afterFit: removePaddingFormScale,
                maxRotation: 0,
             }]
            },
            tooltips: {
              displayColors: false,
              callbacks: {
                title: function(tooltipItems, data) {
                  return '';
                },
                label: function(tooltipItem, data) {
                  return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                },
              }
            }
          }
          self.chart_dataset_override = [{pointRadius:0, pointHitRadius: 20, borderColor: "rgba(100,100,100,0.3)", backgroundColor: "rgba(100,100,100,0.2)"}]
        }
      }
    },
    controllerAs: '$ctrl'
  })
  .directive('tile', function() {
    'use strict';
    return {
      restrict: 'E',
      scope: {
        heading: '@',
        type: '@'
      },
      transclude: true,
      templateUrl: 'framework/partials/ui-elements/tile-generic.html',
      link: function(scope, element) {
        var heading = element.find('tile-heading');
        if (heading.length) {
          heading.appendTo(element.find('.tiles-heading'));
        }
      },
      replace: true
    };
  })